import { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate, useParams } from 'react-router-dom';
import { usePopper } from 'react-popper';

import { Popover, PopoverButton, PopoverItem, StyledPopoverPanel } from '@crazyegginc/hatch';
import { ROOT_ELEMENT_ID } from '/src/features/_global/constants';

import { ReactComponent as MenuIcon } from '@crazyegginc/hatch/dist/images/icon-menu-dots.svg';

export function DetailCardPopover() {
  const { id } = useParams();

  const navigate = useNavigate();

  const [referenceElement, setReferenceElement] = useState(null);
  const [tooltipElement, setTooltipElement] = useState(null);

  const { styles, attributes } = usePopper(referenceElement, tooltipElement, {
    placement: 'bottom',
    modifiers: [
      {
        name: 'flip',
        options: {
          allowedAutoPlacements: 'bottom',
          fallbackPlacements: 'bottom',
        },
      },
      {
        name: 'preventOverflow',
        options: {
          mainAxis: false,
        },
      },
      useMemo(
        () => ({
          name: 'offset',
          options: {
            offset: () => {
              return [0, 5];
            },
          },
        }),
        [],
      ),
    ],
  });

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <div ref={setReferenceElement}>
            <PopoverButton>
              <MenuIcon aria-label="actions" className="h-[14px] w-[14px] fill-current" />
            </PopoverButton>
          </div>
          {open &&
            createPortal(
              <StyledPopoverPanel
                onMouseDown={(e) => e.stopPropagation()}
                align="left"
                className="w-[164px] px-2.5"
                ref={setTooltipElement}
                style={{ ...styles.popper }}
                {...attributes.popper}
              >
                {({ close }) => (
                  <>
                    <PopoverItem
                      autoWidth
                      className="px-2.5"
                      onClick={() => {
                        navigate(`/goals/${id}/edit-value`);
                        close();
                      }}
                    >
                      <div className="flex w-full items-center">
                        <div className="text-sm text-black-pearl-500">Edit value</div>
                      </div>
                    </PopoverItem>
                  </>
                )}
              </StyledPopoverPanel>,
              document.querySelector(`#${ROOT_ELEMENT_ID}`),
            )}
        </>
      )}
    </Popover>
  );
}
